import ReleasesList from "../ReleasesList";
import TrackList from "../TrackList";
import TitleWithBorder from "../TitleWithBorder";
import { Wrapper } from "./styled";
import { useScrollLoading } from "../../hooks/useScrollLoading";
import { EmptyFavorite } from "../EmptyFavorite";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import { useDispatch } from "react-redux";
import { setReleasePodcastInfo } from "../../redux/Slice/releasePodcastSlice";
import { modalState } from "../../utils/constants";
import { openModal } from "../../redux/Slice/modalSlice";

const FavoriteList = ({
  title,
  data,
  handleNextPage,
  isLoading,
  isRelease = true,
}) => {
  const { scrollRef, onScroll } = useScrollLoading(handleNextPage);
  const isMobile = useMediaQuery("(max-width: 900px)");

  const dispatch = useDispatch();

  const handleClickCardRelease = (release) => {
    dispatch(setReleasePodcastInfo(release));

    dispatch(openModal(modalState.RELEASE_PODCAST_INFO));
  };

  return (
    <Wrapper>
      <TitleWithBorder>{title}</TitleWithBorder>
      {!data?.length && <EmptyFavorite withInfo={isMobile} />}
      {isRelease && data?.length ? (
        <div
          ref={scrollRef}
          onScroll={onScroll}
          style={{ overflowY: "auto", height: "85vh" }}
        >
          <ReleasesList
            releases={data ?? []}
            releasesPodcast={data ?? {}}
            isLoading={isLoading}
            showLikeBtn
            onClickCardRelease={handleClickCardRelease}
          />
        </div>
      ) : (
        <TrackList tracks={data ?? []} isLoading={isLoading} />
      )}
    </Wrapper>
  );
};

export default FavoriteList;
